<section *ngIf="routeIsLoading" class="mat-progress-bar-wrapper">
    <mat-progress-bar class="custom-mat-progress-bar" color="primary" mode="indeterminate" [value]="50" [bufferValue]="75"></mat-progress-bar>
</section>
<page-loader #pageLoader></page-loader>
<router-outlet></router-outlet>
